// Ported from cartadigital-pos app/utils/search/normalize.ts.

/**
 * Normalize a string for matching:
 * - lowercase
 * - strip accents/diacritics
 * - collapse whitespace
 * - trim
 */
export function normalizeText(input: string): string {
  let out = String(input ?? '').toLowerCase();

  if (typeof out.normalize === 'function') {
    out = out.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  out = out.replace(/\s+/g, ' ').trim();
  return out;
}

/**
 * Extract digits only (useful for phone searches).
 */
export function digitsOnly(input: string): string {
  return String(input ?? '').replace(/\D+/g, '');
}

/**
 * Split a query into normalized, non-empty terms.
 * Multi-term search semantics: all terms must match.
 */
export function splitTerms(rawQuery: string): string[] {
  const q = normalizeText(rawQuery);
  if (!q) return [];
  return q.split(' ').filter(Boolean);
}
